import request from "@/utils/request";

const loadTeam = () => {
  return request.get("/api/team_members");
};

const removeUserFromTeam = (id) => {
  return request.delete(`/api/team_members/${ id }`, { token: true });
};

const create = ({
  firstname,
  lastname,
  company,
  teamName,
  seats
}) => {
  return request.post("/api/teams", {
    body: {
      "first_name": firstname,
      "last_name": lastname,
      "company_name": company,
      "team_name": teamName,
      seats
    },
    token: true
  });
};

const createLead = ({
  locale
}) => {
  return request.post("/api/teams/leads", {
    body: {
      lead: {
        locale
      }
    },
    token: true
  });
};

export default {
  loadTeam,
  removeUserFromTeam,
  create,
  createLead
};
